'use client'

import { useMemo } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { SearchIcon } from 'lucide-react'
import { motion } from 'motion/react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { stripLocaleFromPath } from '~/i18n/routing'
import { useUserContext } from '~/providers/user-provider'

export const FindACocoonBtn = () => {
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const { t } = useLingui()
	const { userQuery } = useUserContext()

	const isSearchBtnVisible = useMemo(() => {
		const isHome = pathname === '/'

		const isSearch =
			pathname.includes('/paris') ||
			pathname.includes('/lyon') ||
			pathname.includes('/london')

		const isBookingTunnel =
			pathname.includes('/booking') ||
			pathname.includes('/payment') ||
			pathname.includes('/overstay')

		return !isHome && !isSearch && !isBookingTunnel
	}, [pathname])

	return (
		<div className='absolute left-1/2 inline-flex -translate-x-1/2 max-md:hidden'>
			{isSearchBtnVisible && (
				<motion.div
					initial={{ opacity: 0, scale: 0.5 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0, scale: 1.1 }}
				>
					<Button
						data-testid='find-cocoon-button'
						value='gradient'
						className='!px-6'
						asChild
					>
						<Link href={`/${userQuery.data?.default_zone || 'paris'}`}>
							<SearchIcon />
							{t`Trouver un Cocoon`}
						</Link>
					</Button>
				</motion.div>
			)}
		</div>
	)
}
